function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16.3 0.01)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.15.5A9.532,9.532,0,1,1,38.037,6.417,9.527,9.527,0,0,1,50.15.5Z",
  transform: "translate(-17.488 0)",
  className: "accent",
  fill: "#f7e842",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.3 1.273)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.707,41.1a5.407,5.407,0,1,0,5.407,5.407A5.409,5.409,0,0,0,55.707,41.1Zm0,9.971a4.556,4.556,0,1,1,4.547-4.547A4.548,4.548,0,0,1,55.707,51.071Z",
  transform: "translate(-44.331 -35.166)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.258,13.006h2.352a.416.416,0,0,0,.421-.421A.513.513,0,0,0,75,12.426L73.856,7.634a.433.433,0,0,0-.421-.334h0a.448.448,0,0,0-.421.334l-.6,2.423-.579,2.405a.41.41,0,0,0,.088.369A.4.4,0,0,0,72.258,13.006Zm1-2.739.176-.72.632,2.6H72.8Z",
  transform: "translate(-62.076 -7.3)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.645,104.2H72.293a.386.386,0,0,0-.334.158.469.469,0,0,0-.088.369l.579,2.423.6,2.423a.448.448,0,0,0,.421.334h0a.448.448,0,0,0,.421-.334l1.176-4.845a.41.41,0,0,0-.088-.369A.386.386,0,0,0,74.645,104.2Zm-1.176,3.458-.632-2.616H74.1Z",
  transform: "translate(-62.11 -87.189)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.979,19.85a.433.433,0,0,0,.211.316l2.036,1.176a.467.467,0,0,0,.211.053.513.513,0,0,0,.158-.035.435.435,0,0,0,.246-.281l1.4-4.775a.43.43,0,0,0-.72-.421L90.085,19.5A.424.424,0,0,0,89.979,19.85Zm2.949-2.089-.755,2.546-1.088-.632Z",
  transform: "translate(-77.041 -14.267)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.977,97.619a.433.433,0,0,0-.211-.316l-2.036-1.176a.449.449,0,0,0-.369-.035.434.434,0,0,0-.246.281l-.7,2.388-.685,2.388a.45.45,0,0,0,.193.492.467.467,0,0,0,.211.053.44.44,0,0,0,.316-.14l1.7-1.808,1.72-1.808A.324.324,0,0,0,51.977,97.619Zm-2.458,1.562-.492.509.755-2.546,1.088.632Z",
  transform: "translate(-42.198 -80.485)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.156,40.187a.392.392,0,0,0,.035.369l.579,1.018.6,1.018a.45.45,0,0,0,.316.211h.053a.411.411,0,0,0,.3-.123l1.791-1.72,1.808-1.72a.43.43,0,0,0-.421-.72l-4.775,1.4A.587.587,0,0,0,105.156,40.187Zm3.6-.334L106.842,41.7l-.632-1.088Z",
  transform: "translate(-89.532 -33.025)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.277,83.6a.392.392,0,0,0-.035-.369L29.066,81.19a.4.4,0,0,0-.316-.211.424.424,0,0,0-.351.105l-3.616,3.441a.426.426,0,0,0-.07.527.413.413,0,0,0,.369.211.3.3,0,0,0,.123-.018l4.775-1.4A.426.426,0,0,0,30.277,83.6Zm-3.6.334L28.61,82.1l.632,1.088Z",
  transform: "translate(-23.185 -68.041)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.654,64.013l-4.828-1.176a.41.41,0,0,0-.369.088.432.432,0,0,0-.158.334v2.352a.386.386,0,0,0,.158.334.473.473,0,0,0,.263.088.223.223,0,0,0,.105-.018l2.405-.579,2.423-.6a.448.448,0,0,0,.334-.421A.413.413,0,0,0,118.654,64.013Zm-4.494,1.053V63.8l2.6.632Z",
  transform: "translate(-96.271 -53.076)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.479,66.066c.035,0,.07.018.105.018A.473.473,0,0,0,21.848,66a.432.432,0,0,0,.158-.334v-2.37a.386.386,0,0,0-.158-.334.469.469,0,0,0-.369-.088l-4.845,1.176a.433.433,0,0,0-.334.421.448.448,0,0,0,.334.421l2.423.6Zm-.316-2.23V65.1l-1.9-.456-.72-.176Z",
  transform: "translate(-16.3 -53.11)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.634,84.513l-1.773-1.685-1.791-1.72a.421.421,0,0,0-.667.088l-.6,1.018-.579,1.018a.449.449,0,0,0-.035.369.434.434,0,0,0,.281.246l4.775,1.4a.3.3,0,0,0,.123.018h0a.427.427,0,0,0,.421-.421A.348.348,0,0,0,110.634,84.513Zm-4.389-1.334.632-1.088,1.4,1.352.509.492Z",
  transform: "translate(-89.567 -68.046)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.664,42.863a.5.5,0,0,0,.3.123h.07a.433.433,0,0,0,.316-.211l1.176-2.036a.449.449,0,0,0,.035-.369.435.435,0,0,0-.281-.246L25.5,38.72a.43.43,0,0,0-.421.72Zm.825-2.089-.632,1.088-1.931-1.826Z",
  transform: "translate(-23.432 -33.19)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.841,96.437a.434.434,0,0,0-.246-.281.392.392,0,0,0-.369.035L90.19,97.368a.4.4,0,0,0-.211.316.424.424,0,0,0,.105.351l3.441,3.616a.44.44,0,0,0,.316.14h0a.416.416,0,0,0,.421-.421.52.52,0,0,0-.035-.176Zm-1.756,1.387,1.088-.632.755,2.546Z",
  transform: "translate(-77.041 -80.532)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.371,18.691l.7,2.388a.435.435,0,0,0,.246.281.513.513,0,0,0,.158.035.467.467,0,0,0,.211-.053l2.036-1.176a.4.4,0,0,0,.211-.316.424.424,0,0,0-.105-.351l-1.72-1.808-1.7-1.808a.426.426,0,0,0-.527-.07.405.405,0,0,0-.193.492Zm2.458,1-1.088.632L49.2,18.463,49,17.779Z",
  transform: "translate(-42.156 -14.268)",
  className: "primary",
  fill: "#4e4e4e"
})));

var SvgClear = function SvgClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.802,
    height: 24,
    viewBox: "0 0 22.802 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear.8f69a083.svg";
export { ForwardRef as ReactComponent };